import React, { useState } from "react";
import Sidebar from "./components/Sidebar";   // ✅ Adjust path
import TicketTable from "./components/TicketTable";   // ✅ Adjust path
import Stats from "./components/Stats";  // ✅ Import Stats component

const App = () => {
  const [selectedFilter, setSelectedFilter] = useState("ALL");

  return (
    <div className="dashboard-container">
      <Sidebar onFilterChange={setSelectedFilter} />
      <div className="main-content">
      <Stats />  {/* ✅ Stats always visible */}
        <TicketTable selectedFilter={selectedFilter} />
      </div>
    </div>
  );
};

export default App;
